export { default as Image } from './Image';
export type { ImageProps } from './types';
